var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-section"},[_c('img',{attrs:{"src":require('@/assets/images/wm-promotion/main-section/4.png'),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }